import * as React from "react";
import { FiltersPopoverLayout } from "@/components/Filters/FiltersPopoverLayout";
import { formatReviewCount } from "./utils";

type ReviewFiltersPopoverLayoutProps = {
  children: React.ReactNode;
  onClear?: () => void;
  onDone: () => void;
  side?: "right" | "bottom";
  sideOffset?: number;
  initialFocus?: boolean;
  resultCount?: number | null;
};

/** Shared chrome for Coach and Player review filter popovers. */
export function ReviewFiltersPopoverLayout({ resultCount, ...props }: ReviewFiltersPopoverLayoutProps) {
  const resultLabel =
    typeof resultCount === "number" ? formatReviewCount(resultCount) : resultCount === null ? null : undefined;
  return <FiltersPopoverLayout {...props} resultLabel={resultLabel} />;
}
